// Places enkeltmandat into table based on template
export function placeMandater<T>(template: number[][], mandater: T[]): T[][] {
  return template.map(column => column.map(cellIndex => mandater[cellIndex]))
}
